import type { AlpineComponent } from 'alpinejs';

const globalStore = {
	navOpen: false,
	headerSearchOpen: false,
	languageSwitchOpen: false
};

export const global: AlpineComponent<typeof globalStore> = globalStore;
